export const STATE_KEY = 'CollectAccessGrant'
export const FORM_NAME = 'formOauthAuthorize'
export const FORM_ID = 'collect_oauth2_server_access_grant'

export const CONTENT_LOAD = 'Collect/AccessGrant/LOAD'
export const CONTENT_LOAD_SUCCESS = 'Collect/AccessGrant/LOAD_SUCCESS'
export const CONTENT_LOAD_ERROR = 'Collect/AccessGrant/LOAD_ERROR'
